import type { SolutionSubtype, SubtypeOption } from './SolutionSubtypePicker';

/**
 * Maps each custom-made subtype to its catalog card code (@insolech/catalogs)
 * so admin card-visibility toggles (catalog_card_visibility) flow through to the
 * wizard picker. Refurbishment has no marketing card, so it is omitted and is
 * always visible. Pure module (type-only imports) so it can be unit-tested
 * without loading the React picker / Supabase client.
 */
export const SUBTYPE_CARD_CODE: Partial<Record<SolutionSubtype, string>> = {
  pa12_insole: 'CUSTOM-PA12',
  tpu_insole: 'CUSTOM-TPU',
  polypropylene_insole: 'CUSTOM-PP',
  carbon_insole: 'CUSTOM-CARBON',
  eva_insole: 'CUSTOM-EVA',
  fibreglass_insole: 'CUSTOM-FG',
  orthopaedic_sandal: 'CUSTOM-SANDALS',
};

/**
 * Subtypes to show in the picker: drop any whose card an admin disabled on the
 * web app (catalog_card_visibility.web_app_enabled = false), EXCEPT the
 * currently-selected value. The exception is the edit-safety guard: editing an
 * existing order whose material was later disabled must still show (and keep)
 * its tile, so a disable never breaks an in-flight / historical order.
 */
export function visibleSubtypes(
  subtypes: ReadonlyArray<SubtypeOption>,
  value: SolutionSubtype | null | undefined,
  isHidden: (cardCode: string) => boolean,
): SubtypeOption[] {
  return subtypes.filter((opt) => {
    if (opt.id === value) return true;
    const code = SUBTYPE_CARD_CODE[opt.id];
    return !code || !isHidden(code);
  });
}
